// extracted by mini-css-extract-plugin
export default {"ModalStyle":"CustomerModal_ModalStyle__cBuH7"};